import { useEmrContext } from "@/hooks/emr-context";
import { useUpdateActionState } from "./use-update-action-state";

/**
 * Returns a callback that marks the action-center action linked to a composer as done.
 * Used by the letter/form composer bodies so completion is recorded only after the real
 * send/submit succeeds, not when the composer is opened.
 */
export function useCompleteActionFromComposer(actionMeta) {
  var _actionMeta$reminderI;
  var _useEmrContext = useEmrContext(),
    patientUid = _useEmrContext.patientUid;
  var _useUpdateActionState = useUpdateActionState(patientUid, (_actionMeta$reminderI = actionMeta === null || actionMeta === void 0 ? void 0 : actionMeta.reminderId) !== null && _actionMeta$reminderI !== void 0 ? _actionMeta$reminderI : 0),
    mutate = _useUpdateActionState.mutate;
  return function () {
    if (!actionMeta) return;
    mutate({
      actionId: actionMeta.actionId,
      state: "done"
    });
  };
}